import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { Helmet } from 'react-helmet';
import { Button } from '@blueprintjs/core';
import * as DataList from 'components/DataList';
import SettingsPage from 'components/SettingsPage';
import TaxesTable, { TAX_COLUMNS, TAX_CARDS, TAX_MIN_TABLE_WIDTH } from 'components/Tables/Taxes';
import TaxModal from 'components/Taxes/TaxModal';

// Settings > Taxes (/taxes).
@inject('taxStore', 'quickbooksStore', 'xeroStore') @observer
class TaxesIndexPage extends Component {
  @observable isTaxDialogVisible = false;

  componentDidMount() {
    this.props.taxStore.loadTaxes();
  }

  openTaxModal = () => {
    this.isTaxDialogVisible = true;
    this.props.quickbooksStore.loadQuickbooksTaxCodes();
    this.props.xeroStore.loadXeroTaxCodes();
  };

  render() {
    const { taxStore } = this.props;
    const { isLoading, isError, objects } = taxStore.taxes;
    let content;
    if (isLoading) {
      content = <DataList.Loading columns={TAX_COLUMNS} cards={TAX_CARDS} minTableWidth={TAX_MIN_TABLE_WIDTH} noun="taxes" rows={4} />;
    } else if (isError) {
      content = <DataList.LoadError noFilters noun="taxes" onRetry={() => taxStore.loadTaxes()} />;
    } else if (objects) {
      content = <TaxesTable onAdd={this.openTaxModal} />;
    }
    return (
      <React.Fragment>
        <Helmet>
          <title>Taxes | FieldNexus</title>
        </Helmet>
        <SettingsPage
          title="Taxes"
          description="The rates you can put on estimates and invoices."
          actions={<Button className="sp-button sp-button--primary" icon="add" text="Add tax" onClick={this.openTaxModal} />}
        >
          {content}
        </SettingsPage>
        <TaxModal
          isOpen={this.isTaxDialogVisible}
          title="Add Tax"
          edit={false}
          onClose={() => { this.isTaxDialogVisible = false; }}
          onSuccess={() => { this.isTaxDialogVisible = false; }}
        />
      </React.Fragment>
    );
  }
}

export default TaxesIndexPage;
